import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const TitleText = styled(Typography)(({ theme }) => ({
  color: '#657787',
  fontFamily: 'Quicksand',
  fontSize: '20px',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '24px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
  },
}))

export const ChangeLoginTypeText = styled(Typography)(({ theme }) => ({
  color: '#596B7B',
  fontFamily: 'Zen Kaku Gothic Antique',
  fontSize: '15px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '24px',
   [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
  },
}))

export const ChangeLoginTypeLink = styled('span')(({ theme }) => ({
  color: '#8D92BE',
  fontFamily: 'Zen Kaku Gothic Antique',
  fontSize: '15px',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '24px',
  cursor: 'pointer',
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
  },
}))

export const ForgotPasswordButton = styled(Typography)({
  color: '#8D92BE',
  textAlign: 'center',
  fontFamily: 'Zen Kaku Gothic Antique',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '18px',
  cursor: 'pointer',
})
